import type { SnippetType } from "../../types";

/**
 * Visual contract consumed by generic snippet layouts. New brands fill this
 * in on BrandConfig instead of adding `if (brandId === …)` in the renderer.
 */
export type SnippetStyleProfile = {
  headerMode: "saturatedBar" | "thinStrip" | "numberedRule";
  /** When true, item fills are derived from headerColor (legacy rainbow). */
  shadeItemsFromHeader: boolean;
  surface: "accentFlood" | "lightGrey" | "white" | "pastel";
  packFromTop: boolean;
  maxRowHeightPt?: number;
  /** Hex fill used when surface is "pastel". */
  pastelFill?: string;
};

export const GENERIC_SNIPPET_TYPES: readonly SnippetType[] = [
  "processFlow",
  "kpiDashboard",
  "orgChart",
  "comparisonColumns",
  "statGrid",
  "sectionBlock",
  "columnCards",
  "iconTextRows",
  "quadrantGrid",
  "numberedRows",
  "bulletBox",
  "splitContent",
];

export const CITI_EXTRA_SNIPPET_TYPES: readonly SnippetType[] = [
  "citiTextTable",
  "citiQuadrant",
  "citiSplitContent",
  "citiTombstone",
  "citiMatrix",
];

export const DEFAULT_SNIPPET_STYLE_PROFILE: SnippetStyleProfile = {
  headerMode: "thinStrip",
  shadeItemsFromHeader: false,
  surface: "white",
  packFromTop: true,
  maxRowHeightPt: 64,
};

export const CITI_SNIPPET_STYLE_PROFILE: SnippetStyleProfile = {
  headerMode: "saturatedBar",
  shadeItemsFromHeader: true,
  surface: "accentFlood",
  packFromTop: false,
};

export const UBS_SNIPPET_STYLE_PROFILE: SnippetStyleProfile = {
  headerMode: "thinStrip",
  shadeItemsFromHeader: false,
  surface: "pastel",
  packFromTop: true,
  maxRowHeightPt: 64,
  pastelFill: "#ECEBE4",
};

export function snippetTypeEnumFor(
  extraSnippetTypes: readonly string[] | undefined,
  typeFilter?: { allow?: readonly string[]; deny?: readonly string[] }
): string[] {
  let types: string[] = [
    ...GENERIC_SNIPPET_TYPES,
    ...(extraSnippetTypes ?? []),
  ];
  if (typeFilter?.allow && typeFilter.allow.length > 0) {
    const allow = new Set(typeFilter.allow);
    types = types.filter((type) => allow.has(type));
  }
  if (typeFilter?.deny && typeFilter.deny.length > 0) {
    const deny = new Set(typeFilter.deny);
    types = types.filter((type) => !deny.has(type));
  }
  return types;
}
